/*
  PUSH NOTIFICATION ACTIONS
 */

export const PUSH_NOTIFICATIONS_GET_STATUS = "PUSH_NOTIFICATIONS_GET_STATUS";
export const PUSH_NOTIFICATIONS_SET_STATUS = "PUSH_NOTIFICATIONS_SET_STATUS";
export const PUSH_NOTIFICATIONS_UPDATE = "PUSH_NOTIFICATIONS_UPDATE";

export const FETCH_PUSH_NOTIFICATIONS = "FETCH_PUSH_NOTIFICATIONS";
export const FETCH_PUSH_NOTIFICATIONS_SUCCESS = "FETCH_PUSH_NOTIFICATIONS_SUCCESS";
export const FETCH_PUSH_NOTIFICATIONS_FAILURE = "FETCH_PUSH_NOTIFICATIONS_FAILURE";

export const CREATE_PUSH_NOTIFICATION = "CREATE_PUSH_NOTIFICATION";
export const CREATE_PUSH_NOTIFICATION_SUCCESS = "CREATE_PUSH_NOTIFICATION_SUCCESS";
export const CREATE_PUSH_NOTIFICATION_FAILURE = "CREATE_PUSH_NOTIFICATION_FAILURE";

export const DELETE_PUSH_NOTIFICATION = "DELETE_PUSH_NOTIFICATION";
